import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { DialogRef } from '@angular/cdk/dialog';

export interface PerioResetAllChangesModalResult {
  reset?: boolean;
}

@Component({
  selector: 'lib-perio-reset-all-changes-modal',
  imports: [CommonModule, TranslatePipe],
  templateUrl: './perio-reset-all-changes-modal.component.html',
  styleUrl: './perio-reset-all-changes-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PerioResetAllChangesModalComponent {
  private readonly dialogRef = inject(DialogRef);

  protected onCancelClicked(): void {
    this.dialogRef.close({ reset: false });
  }

  protected onResetClicked(): void {
    this.dialogRef.close({ reset: true });
  }
}
